import {PATH} from "./const";
import {ApiFindOptions, useApiFind} from "../../../../../lib/HttpService";
import {StubbornService} from "../../../../../application/business/StubbornAsset";

export const useEditionServiceFind = (options: ApiFindOptions = {}) => useApiFind<StubbornService>(PATH, options);
